export enum OrganizationRoleType {
  admin = 'admin',
  regular_user = 'regular_user',
}

export enum RoleType {
  admin = 'admin',
  manager = 'manager',
  full_member = 'full_member',
}

export type Member = {
  id: string;
  memberId: string;
  avatar: {
    color: string;
    initials: string;
    profilePictureUrl: string;
    label: string;
  };
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  slug: string;
  userId: number;
  organizationRole: OrganizationRoleType;
  role: RoleType;
  department: string;
  type: string;
  confirmedAt: string;
  confirmationSentAt: string;
  lastSeenAt: string;
  title: string;
  managerId: string;
  piUserGuid?: string;
  primary: boolean;
};
